const cardData = [
  {
    id: "1",
    title: "bMovies (React JS, AXIOS)",
    img: "./images/bMovies.jpeg",
    demo: "https://bmovies-info.netlify.app/",
    github:
      "https://github.com/BogdanBTS/Beetroot_projects/tree/master/Movie_app/my-app/",
    description: `This responsive React web application seamlessly provides information about movies, TV series, and actors. It features a robust search functionality and utilizes the TMDB database through the AXIOS API for data retrieval.`,
  },

  {
    id: "2",
    title: "My Portfolio (React JS)",
    img: "./images/myPortfolio.jpg",
    demo: "https://bogdan-tsaruk.netlify.app/",
    github: "https://github.com/BogdanBTS/myPortfolio",
    description: `This responsive React web project showcases my personal portfolio and is the most recent one. Crafted solely using React, GRID, FLEX, and CSS Modules, it features captivating animations and accessible features that elevate the user experience.`,
  },

  {
    id: "3",
    title: "Perfect Job (React Native)",
    img: "./images/perfectJob.jpg",
    demo: "https://youtu.be/eH3IbY-09NA?si=4xP6wpFdtop1EZ8b",
    github: "https://github.com/BogdanBTS/perfect_job_react_native",
    description: `This is a job search React Native application using Rapid API (JSearch) and Expo tools, including Expo Router.`,
  },
];

export default cardData;
